import get from 'lodash.get';

export const selectAggridSearchValue = (state) => get(state, 'aggridSearchBar.searchValue');
